import { authDelete, authGet, authPost, authPut } from '../../../../shared/sso-workspace/auth-api'

const p = 'alert-routing'
export const getTriggers = () => authGet(`${p}/triggers`)
export const getActionTypes = () => authGet(`${p}/action-types`)
export const getCategories = () => authGet(`${p}/categories`)
export const listRoutes = category => authGet(`${p}/routes`, { category })
export const getRoute = id => authGet(`${p}/routes/${id}`)
export const createRoute = body => authPost(`${p}/routes`, body)
export const updateRoute = (id, body) => authPut(`${p}/routes/${id}`, body)
export const deleteRoute = id => authDelete(`${p}/routes/${id}`)
export const routeState = (id, action) => authPost(`${p}/routes/${id}/${action}`, {})
export const testRoute = (id, body) => authPost(`${p}/routes/${id}/test`, body)
export const previewRoute = body => authPost(`${p}/routes/preview`, body)
export const listTargets = () => authGet(`${p}/targets`)
export const getTarget = id => authGet(`${p}/targets/${id}`)
export const createTarget = body => authPost(`${p}/targets`, body)
export const updateTarget = (id, body) => authPut(`${p}/targets/${id}`, body)
export const deleteTarget = id => authDelete(`${p}/targets/${id}`)
export const addAddress = (id, body) => authPost(`${p}/targets/${id}/addresses`, body)
export const removeAddress = (id, addressID) => authDelete(`${p}/targets/${id}/addresses/${addressID}`)
// body: { field, secret } or { field, rotate: true }; a rotate answers { set, secret }.
// The secret travels only as `secret`, a key the request log masks.
export const setSecret = (id, body) => authPut(`${p}/targets/${id}/secret`, body)
export const setPersonal = (id, allow) => authPut(`${p}/targets/${id}/personal-data`, { allow })
export const testTarget = id => authPost(`${p}/targets/${id}/test`, {})
export const listRuns = params => authGet(`${p}/runs`, params)
export const getRun = id => authGet(`${p}/runs/${id}`)
export const retryRun = id => authPost(`${p}/runs/${id}/retry`, {})
export const resolveRun = id => authPost(`${p}/runs/${id}/resolve`, {})
export const getCoverage = () => authGet(`${p}/sso-coverage`)
